import React from 'react'
import { Grid, IconButton, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  actionIcon: {
    margin: '0 auto',
    display: 'block',
    color: theme.palette.primary.main,
  },

  actionIconLabel: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: 11,
    fontFamily: 'Poppins',
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
}))

const ActionIcon = ({ Icon, fontSize, label, website, onClickAction }) => {
  const classes = useStyles()

  return (
    <Grid item>
      <IconButton
        classes={{ label: classes.actionIconLabel }}
        href={website}
        target='_blank'
        rel='noopener noreferrer'
        onClick={(event) => {
          event.stopPropagation()
          if (onClickAction) {
            onClickAction()
          }
        }}
      >
        <Icon
          className={classes.actionIcon}
          fontSize='large'
          style={{ fontSize: fontSize ? fontSize : '' }}
        />
        <Typography variant='h6' className={classes.actionIconLabel}>
          {label}
        </Typography>
      </IconButton>
    </Grid>
  )
}

export default ActionIcon
